import { pbx_module_breadcrumbs } from '@pbx/breadcrumbs/_module';

export const pbx_operators_base_breadcrumbs = pbx_module_breadcrumbs
  .extend('pbx.operator.index')
  .add('pbx.breadcrumb.operator.index', { name: 'pbx.operator.index' });
